import React, { useState, useRef, useEffect } from 'react'
import { navigate } from 'gatsby'
import Button from '../components/button'
import InputMask from 'react-input-mask'

import styled from 'styled-components'
import classnames from 'classnames'

const ButtonContainer = styled.div`
  margin-top: 1em;
  text-align: center;
  button {
    width: 100%;
    max-width: 380px;
  }
`

function EstimateForm({
  style,
  showLabels,
  pageTitle,
  pageProps,
  pageLocation,
  showPlaceHolders,
  offerPageStyle = false,
  prependDisclosureText,
  className,
  actionButtonText,
  blogPost,
}) {
  const [spamFilter, updateSpamFilterStatus] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false) // Track submission status
  const [sessionSource, setSessionSource] = useState('')
  const [url, setUrl] = useState(pageLocation || 'URL not provided')
  const [landingURL, setLandingURL] = useState('')

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      )
      .join('&')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (
      phone.includes('(171') ||
      phone.includes('(191') ||
      phone.includes('(121')
    ) {
      updateSpamFilterStatus(true)
      return false
    }
    setIsSubmitting(true) // Disable the button

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'free-estimate-form',
        subject: `GVD Form Submission - ${firstName} ${lastName}`,
        firstname: firstName,
        lastname: lastName,
        url: url,
        landingURL: landingURL,
        email: email,
        phone: phone,
        description: description,
        referrer: document.referrer,
        ['bot-field']: botField,
        session_source: sessionSource,
      }),
    })
      .then(() =>
        navigate('/thanks', {
          state: { firstname: firstName, lastName: lastName, email: 'test' },
        })
      )
      .catch((error) => {
        alert(error)
        setIsSubmitting(false) // Re-enable the button if an error occurs
      })
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Capture landing URL and session source
      const storedLandingURL = window.localStorage.getItem('landingURL')
      const landingURL = storedLandingURL || window.location.href
      setLandingURL(landingURL)

      const params = new URLSearchParams(window.location.search)
      let source = 'Direct'

      if (params.has('utm_source')) {
        source = params.get('utm_source')
      } else if (document.referrer) {
        try {
          const referrerURL = new URL(document.referrer)
          source = referrerURL.hostname
        } catch (error) {
          console.log('Error parsing referrer URL', error)
        }
      }

      // Fallback check to see if the source was previously stored
      const storedSource = window.localStorage.getItem('sessionSource')
      if (storedSource) {
        source = storedSource
      }

      setSessionSource(source)
      window.localStorage.setItem('sessionSource', source)
      window.localStorage.setItem('landingURL', landingURL)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedSource = window.localStorage.getItem('sessionSource')
      if (storedSource) {
        setSessionSource(storedSource)
      }
    }
  }, [])

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [description, setDescription] = useState('')
  const [errors, updateErrors] = useState([])
  const [botField, setBotField] = useState('')

  return (
    <>
      <form
        onSubmit={(e) => handleSubmit(e)}
        name="free-estimate-form"
        method="post"
        action="/success"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        className={
          style
            ? style + ' mt-4 mb-0 mx-auto'
            : 'contact-form-default-style mt-4 mb-0 mx-auto'
        }
      >
        <input
          type="hidden"
          name="bot-field"
          value={botField}
          onChange={(e) => setBotField(e.target.value)}
        />

        <input type="hidden" name="form-name" value="free-estimate-form" />
        <input type="hidden" name="firstname" />
        <input type="hidden" name="lastname" />
        <input type="hidden" name="email" />
        <input type="hidden" name="phone" />
        <input type="hidden" name="url" />
        <input type="hidden" name="landingURL" />
        <input type="hidden" name="description" />
        <input type="text" className="hidden" name="referrer" />
        <input type="hidden" id="subject" name="subject" />
        <input type="hidden" name="session_source" value={sessionSource} />

        <div className="grid grid-cols-1 row-gap-3 col-gap-4 sm:grid-cols-6 gap-y-4 mt-5">
          <div className={`${offerPageStyle ? 'col-span-6' : 'sm:col-span-3'}`}>
            <label
              htmlFor="firstname"
              className={`block mb-1 text-base font-medium leading-5 ${
                offerPageStyle ? 'text-white' : 'text-gray-800'
              } ${!showLabels ? 'sr-only' : ''}`}
            >
              First Name
            </label>
            <div
              className={classnames({
                'border-radius shadow-sm': true,
                'mt-1': blogPost,
              })}
            >
              <input
                id="firstname"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={showPlaceHolders ? 'First Name' : ''}
                className="form-control  "
                required={true}
              />
            </div>
          </div>

          <div
            className={`${offerPageStyle ? 'col-span-6' : 'sm:col-span-3'}  ${
              !offerPageStyle ? 'sm:pl-4' : ''
            }`}
          >
            <label
              htmlFor="lastname"
              className={`block mb-1 text-base font-medium leading-5 ${
                offerPageStyle ? 'text-white' : 'text-gray-800'
              } ${!showLabels ? 'sr-only' : ''}`}
            >
              Last Name
            </label>
            <div
              className={classnames({
                'border-radius shadow-sm': true,
                'mt-1': blogPost,
              })}
            >
              <input
                id="lastname"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="form-control"
                placeholder={showPlaceHolders ? 'Last Name' : ''}
                required={true}
              />
            </div>
          </div>

          <div className={offerPageStyle ? 'col-span-6' : 'sm:col-span-3'}>
            <label
              htmlFor="email"
              className={`block mb-1 text-base font-medium leading-5 ${
                offerPageStyle ? 'text-white' : 'text-gray-800'
              } ${!showLabels ? 'sr-only' : ''}`}
            >
              Email address
            </label>
            <div
              className={classnames({
                'border-radius shadow-sm': true,
                'mt-1': blogPost,
              })}
            >
              <input
                type="email"
                name="email"
                id="email"
                value={email}
                placeholder={showPlaceHolders ? 'Email' : ''}
                required={true}
                onChange={(e) => {
                  setEmail(e.target.value)
                  if (
                    e.target.value.match(
                      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
                    ) == null
                  ) {
                    if (typeof e.target.setCustomValidity !== 'function') {
                      updateErrors([
                        ...errors.filter(([field]) => field !== 'email'),
                        [
                          'email',
                          'Please enter a valid domain at the end of your email address',
                        ],
                      ])
                    } else {
                      e.target.setCustomValidity(
                        'Please enter a valid domain at the end of your email address'
                      )
                    }
                  } else {
                    e.target.setCustomValidity('')
                    if (typeof e.target.setCustomValidity !== 'function')
                      updateErrors([
                        ...errors.filter(([field]) => field !== 'email'),
                      ])
                  }
                }}
                className="form-control "
              />
            </div>
            {errors.filter(([field]) => field === 'email')[0] && (
              <div className="text-red-700">
                {errors.filter(([field]) => field === 'email')[0][1]}
              </div>
            )}
          </div>

          <div
            className={`${offerPageStyle ? 'col-span-6' : 'sm:col-span-3'} ${
              !offerPageStyle ? 'sm:pl-4' : ''
            }`}
          >
            <label
              htmlFor="phone"
              className={`block mb-1 text-base font-medium leading-5 ${
                offerPageStyle ? 'text-white' : 'text-gray-800'
              } ${!showLabels ? 'sr-only' : ''}`}
            >
              Phone
            </label>
            <div
              className={classnames({
                'border-radius shadow-sm': true,
                'mt-1': blogPost,
              })}
            >
              <InputMask
                type="tel"
                name="phone"
                id="phone"
                placeholder={showPlaceHolders ? 'Phone' : ''}
                className="form-control "
                mask="(999) 999-9999"
                onChange={(e) => {
                  setPhone(e.target.value)
                  if (
                    e.target.value.match(
                      /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
                    ) == null
                  ) {
                    if (typeof e.target.setCustomValidity !== 'function') {
                      updateErrors([
                        ...errors.filter(([field]) => field !== 'phone'),
                        ['phone', 'Please enter a complete phone number'],
                      ])
                    } else {
                      e.target.setCustomValidity(
                        'Please enter a complete phone number'
                      )
                    }
                  } else {
                    e.target.setCustomValidity('')
                    if (typeof e.target.setCustomValidity !== 'function')
                      updateErrors([
                        ...errors.filter(([field]) => field !== 'phone'),
                      ])
                  }
                }}
                required
              />
            </div>
            {errors.filter(([field]) => field === 'phone')[0] && (
              <div className="text-red-700">
                {errors.filter(([field]) => field === 'phone')[0][1]}
              </div>
            )}
          </div>

          <div className={offerPageStyle ? 'col-span-6' : 'sm:col-span-6'}>
            <label
              htmlFor="description"
              className={`block mb-1 text-base font-medium leading-5 ${
                offerPageStyle ? 'text-white' : 'text-gray-800'
              } ${!showLabels ? 'sr-only' : ''}`}
            >
              Tell us about your project
            </label>
            <div
              className={classnames({
                'border-radius shadow-sm': true,
                'mt-1': blogPost,
              })}
            >
              <textarea
                id="description"
                type="text"
                rows="3"
                value={description}
                placeholder={
                  showPlaceHolders ? 'Tell us about your project' : ''
                }
                onChange={(e) => setDescription(e.target.value)}
                className=" form-control "
                required
              ></textarea>
            </div>{' '}
          </div>
        </div>
        <div className="border-t border-gray-200 pt-1 w-full">
          <ButtonContainer>
            {spamFilter && (
              <div className="font-bold bg-red-600 p-2 px-4 mb-2 text-white">
                An Error Occured. Give Us A Call.
              </div>
            )}
            <Button
              role="submit"
              type="submit"
              color="primary"
              className={'shadow-lg w-full'}
              disabled={isSubmitting} // Disable button when submitting
            >
              {isSubmitting
                ? 'Submitting...'
                : actionButtonText
                ? actionButtonText
                : 'Get FREE Estimate'}{' '}
              →
            </Button>
          </ButtonContainer>
        </div>
        <div
          className={
            'flex items-center justify-center mt-5 text-gray-700 formdisclosure' +
            (offerPageStyle ? ' offerpage-disclosure' : '')
          }
        >
          <img
            width="23px"
            className="privacylock align-middle pr-0"
            alt="We value your privacy."
            src="https://images.ctfassets.net/79nimht05j33/6B0T1lbanuvwPNCq3yeMkE/883b219d111479c11d58e9a81ea90d83/lock.svg"
          />
          {prependDisclosureText}
          *By submitting this form, you consent to receive calls and texts from
          us about your project. Msg/data rates may apply. Reply STOP to opt
          out.
        </div>
      </form>
    </>
  )
}

export default EstimateForm
